const DriverType = {
    E_HAILING: 'e-hailing',
    CHAUFFEUR: 'chauffeur',
}

export default DriverType 
